:host {
  --aha-menu-group--color: var(--theme-primary-text);
  --aha-menu-group--background-color: transparent;

  display: block;
  cursor: default;
  background-color: var(--aha-menu-group--background-color);
  color: var(--aha-menu-group--color);
}
:host([hidden]) {
  /* Important is needed because hidden is a user agent style, and so has extremely low specificity, meaning just about any CSS will override it. Since `hidden` should actually have some real value to it, need to make it stronger.
  https://css-tricks.com/the-hidden-attribute-is-visibly-weak/
  */
  display: none !important;
}

slot[name='label'] {
  display: block;
  padding: var(--spacer-1) var(--spacer-2);
  color: var(--aha-gray-500);
  text-transform: uppercase;
  font-weight: 600;
  font-size: 12px;
  color: var(--theme-tertiary-text);
}

slot {
  margin-left: var(--aha-menu-content--horizontal-padding);
  margin-right: var(--aha-menu-content--horizontal-padding);
}
